import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tokenomics',
  templateUrl: './tokenomics.component.html',
  styleUrls: ['./tokenomics.component.scss']
})
export class TokenomicsComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

  scroll(element: HTMLHeadingElement) {
    element.scrollIntoView();
  }
}
